import React from 'react';
import core, { App } from '@gin-betting/core';

import ui from 'modules/ui';
import { Odd, OddStub } from 'components';
import BetslipStub from './BetslipStub';
import handleBetslipModuleLoad from './handleBetslipModuleLoad';

export { loadRestrictionModule } from './handleBetslipModuleLoad';

type OddProps = PropsFromReactComponent<typeof Odd>;

const {
    hocs: { withAsyncLoad },
    entities: {
        components: { makeOddContainerFor },
    },
    utils: { getBettingOptions },
} = core;
const {
    components: { OddFormat },
} = ui;

const BETSLIP_LOADING_DELAY = 1200;
const OddContainer = makeOddContainerFor<OddProps>();

export const loadBetslipModule = () =>
    import(
        /* webpackChunkName: "betslip-module" */ '../index'
    ).then(betslipModule => handleBetslipModuleLoad(betslipModule));

/* eslint-disable react/display-name */
export const AsyncOddButton = withAsyncLoad({
    loader: loadBetslipModule,
    delayLoading: BETSLIP_LOADING_DELAY,
    loading: props =>
        React.createElement(OddFormat, null, (oddFormat: App.OddFormat) =>
            React.createElement(OddContainer, {
                oddId: props.oddId,
                props: { ...props, oddFormat },
                component: props.oddId ? Odd : (OddStub as typeof Odd),
            })
        ),

    componentToRender: 'OddButton',
});

export const AsyncBetslipList = withAsyncLoad({
    loader: loadBetslipModule,
    delayLoading: BETSLIP_LOADING_DELAY,
    loading: props => {
        const {
            url: { pagePath },
        } = getBettingOptions();

        const isBettingPage = pagePath === '';

        if (!isBettingPage) return null;

        return React.createElement(BetslipStub, props);
    },
    componentToRender: 'BetslipList',
});

export const AsyncBetslipListSubscription = withAsyncLoad({
    loader: loadBetslipModule,
    delayLoading: BETSLIP_LOADING_DELAY,
    loading: () => null,
    componentToRender: 'BetslipListSubscription',
});

export const AsyncBetslipBetCount = withAsyncLoad({
    loader: loadBetslipModule,
    delayLoading: BETSLIP_LOADING_DELAY,
    loading: () => null,
    componentToRender: 'BetslipBetCount',
});

export const AsyncOddHistory = withAsyncLoad({
    loader: loadBetslipModule,
    delayLoading: BETSLIP_LOADING_DELAY,
    loading: () => null,
    componentToRender: 'OddHistory',
});

export const AsyncQuickBetslip = withAsyncLoad({
    loader: loadBetslipModule,
    delayLoading: BETSLIP_LOADING_DELAY,
    loading: () => null,
    componentToRender: 'QuickBetslip',
});
